import axios from "axios";
import React, { useEffect, useState } from "react";
import { discountGroupObjects, store_availability_fields } from "../data";
import { GlobalState } from "context/GlobalContext";
import { Box, Divider, Typography } from "@mui/material";
import { arrType, inputTypes, selectOptKeyName } from "data/globalData";
import RenderInputField from "components/MboPaymentWorking/CommonComponents/RenderInputFiled/RenderInputFiled";


export const getUniqueFieldData = (data, field) => {
	return [...new Set(data?.map((item) => item[field]))]
		.filter(Boolean)
		.map((value) => ({
			name: value,
			key: value,
		}));
};

function StoreAvailabilitySection({ value, setValue, disable, data }) {
	const [filterColumns, setFilterColumns] = useState(store_availability_fields);
	const { setSnackBar, snackBar, setLoadingOpen } = GlobalState();

	let filteredData = data
	let stateData = []
	let cityData = []
	let storeGradeData = []
	let storeData = []

	if (value?.[discountGroupObjects.store_availability.key]?.zone?.length) {
		stateData = filteredData.filter((item) => value?.[discountGroupObjects.store_availability.key]?.zone.includes(item?.zone));
	}
	if (value?.[discountGroupObjects.store_availability.key]?.state?.length) {
		cityData = stateData.filter((item) => value?.[discountGroupObjects.store_availability.key]?.state.includes(item?.state));
	}
	if (value?.[discountGroupObjects.store_availability.key]?.city?.length) {
		storeGradeData = cityData.filter((item) => value?.[discountGroupObjects.store_availability.key]?.city.includes(item?.city));
	}
	if (value?.[discountGroupObjects.store_availability.key]?.store_grade?.length) {
		storeData = storeGradeData.filter((item) => value?.[discountGroupObjects.store_availability.key]?.store_grade.includes(item?.store_grade));
	}

	return (
		<Box pl={2} width="90%">
			<Box display="flex" columnGap={"2%"} rowGap="10px" flexWrap="wrap">
				{filterColumns?.map((row) => {
					let option_data = row.option_data ? row.option_data : {};
					if (row?.key === "zone") {
						option_data = {
							type: arrType,
							list: getUniqueFieldData(data, "zone"),
						};
					}
					if (row?.key === "state") {
						option_data = {
							type: arrType,
							list: getUniqueFieldData(stateData, "state"),
						};
					}
					if (row?.key === "city") {
						option_data = {
							type: arrType,
							list: getUniqueFieldData(cityData, "city"),
						};
					}
					if (row?.key === "store_grade") {
						option_data = {
							type: arrType,
							list: getUniqueFieldData(storeGradeData, "store_grade"),
						};
					}
					if (row?.key === "store") {
						option_data = {
							type: arrType,
							list: getUniqueFieldData(storeData, "store_name"),
						};
					}
					return (
						<RenderInputField
							column={{ ...row, option_data }}
							data={value}
							setData={setValue}
							width="49%"
							selectOptObjName={"option_data"}
							key={row.key}
							disabled={disable}
						/>
					);
				})}
			</Box>
		</Box>
	);
}

export default StoreAvailabilitySection;
